export class ResponseEstadoFaseAnualModel{
    payload:EstadoFaseAnualModel;

    constructor(){
        this.payload = new EstadoFaseAnualModel();
    }
}

export class EstadoFaseAnualModel{    
    idJardin:number;
    idJardinPeriodo:number;
    estadoAnio1:boolean;
    estadoAnio2:boolean;
    estadoAnio3:boolean;
    constructor(){
        this.idJardin = -1;
        this.idJardinPeriodo = -1;
        this.estadoAnio1 = false;
        this.estadoAnio2 = false;
        this.estadoAnio3 = false;

    }
}

